export const environment = {
  systemName: 'Linhas - Transportes do Douro, Tâmega e Sousa',
  systemNameShort: 'Linhas',
  devBy: 'Wegoshare, Lda.',
  devByShort: 'Wegoshare',
  phoneNumberGeneral: '255 718 347',
  phoneNumberGeneralClean: '00351255718347',
  // Recaptcha
  recaptcha: {
    siteKey: '6Lcwk88UAAAAAF2NCXlhodBXsysOkbPcnjnUo_rv',
  },
  mapboxToken: 'pk.eyJ1Ijoid2dzLXN3IiwiYSI6ImNtamQ2MGxkbDAyNm0zZXM1ZDM2YTU4aXQifQ.Jh3eR2v9Nr5q0AVMMVph8A',
  // Language options
  defaultLanguage: 'pt-pt',
  systemLanguages: [
    { "code": "pt-pt", "name": "Português", "flag": 'assets/img/portugal.svg' },
    { "code": "en-us", "name": "English", "flag": 'assets/img/united-kingdom.svg' },
  ],
  // Map Style && Options
  mapCenter:{
    lat: 41.201235371328465,
    lon: -8.289045314286222
  },
  mapZoom: 15,
  mapOptions: {
    mapTypeControl: true,
    zoomControl: true,
    streetViewControl: false,
    fullscreenControl: false,
    scrollwheel: true,
    cameraControl: false,
    disableDoubleClickZoom: true,
    maxZoom: 19,
    minZoom: 9,
    styles: [
      {
        "featureType": "all",
        "elementType": "labels.text",
        "stylers": [
          {
            "color": "#878787"
          }
        ]
      },
      {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "administrative.neighborhood",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "color": "#cc0e0e"
          }
        ]
      },
      {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
          {
            "color": "#f9f5ed"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#c9c9c9"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
          {
            "color": "#aee0f4"
          }
        ]
      }
    ],
  },
  // Api Url
  apiUrl: 'https://services.cimts.wegoshare.com/v3',
  extApiUrl: 'https://serverapp.cimts.wegoshare.com/api/cimtamegaesousa',
  cmsUrl: 'https://content.wegoshare.com/api/',
  cmsKey: 'b7eba1c1240c0ac0b0121c26ef3caaab9c03ce632b67e16893686a0847327cc82434368fbf6ca140d6621793817b9991e6f4944a7f31fe521ed044c8d5efdfca735990e7befddc9dce4d6f6e6b3c4a096b56cc02915f1b9c4aa574bb49a5eb2b884959b53cbe704d71ec3ec9606a03e869287b635262aed561a587cd820a2f5b',

  schedulesUrl:'https://storage.googleapis.com/wgs-prd/cimts-schedules/'
}
